import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { TrainingNavbar } from "./reusedcomponent/navbar";
import DatePicker from "react-datepicker";
import { ApiService } from "../../../../services/ApiService";
import { Formik, Form, Field } from "formik";
import { useAlert } from "react-alert";

export default function EditTheme({
  closeModal,
  alert,
  users,
  getThemes,
  theme,
}) {
  console.log("theme", theme);
  return (
    <React.Fragment>
      <Formik
        initialValues={{
          name: theme.name,
          due_date: new Date(theme.due_date),
          email: theme.email,
          theme: theme.theme,
          id: theme.id,
        }}
        onSubmit={(values) => {
          ApiService.post(
            `trainings/update-theme-of-the-week/${theme.id}`,
            values
          ).then((res) => {
            console.log(res);
            if (res.data.type === false) {
              alert.error(res.data.msg);
            } else if (res.data.type === true) {
              alert.success(res.data.msg);
            }
            closeModal();
            getThemes();
          });
        }}
      >
        {({ handleSubmit, values, isSubmitting, setFieldValue }) => (
          <Form>
            <div className="form-group">
              <label>
                Presenter <span className="text-danger"> * </span>
              </label>

              <Field as="select" className="form-control" name="name">
                <option selected>--Select User--</option>

                {users.map((user, i) => (
                  <option
                    value={user.first_name + " " + user.last_name}
                    key={i}
                  >
                    {user.first_name + " " + user.last_name}
                  </option>
                ))}
              </Field>
            </div>

            <div className="form-group">
              <label>
                Presenter Email <span className="text-danger"> * </span>
              </label>
              <Field as="select" className="form-control" name="email">
                <option selected>--Select User--</option>
                {users.map((user, i) => (
                  <option value={user.email} key={i}>
                    {user.email}
                  </option>
                ))}
              </Field>
            </div>
            <div className="form-group">
              <label>
                Due Date <span className="text-danger"> * </span>
              </label>
              <div className="form-group">
                <DatePicker
                  selected={values.due_date}
                  dateFormat="MMMM d, yyyy"
                  className="form-control"
                  name="due_date"
                  minDate={new Date()}
                  onChange={(date) => setFieldValue("due_date", date)}
                />
              </div>
            </div>

            <div className="form-group">
              <label>
                Theme <span className="text-danger"> * </span>
              </label>
              <Field
                as="textarea"
                type="text"
                col="4"
                id="tpoic"
                className="form-control item"
                name="theme"
                placeholder="Enter Theme"
                required
              />
            </div>

            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/trainingmanagement/themeoftheweek/edit_theme.js